import { ResourceName } from 'volta/models/activity';
import { eqFilter, inFilter, niFilter } from 'volta/utils/filters-utils';

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

import type BvMetricsService from 'volta/services/bv-metrics';
import type { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';

interface IArgs {
  entityType?: string;
  entityId?: string;
  userId?: string;
}

export default class ActivityFeed extends Component<IArgs> {
  @service bvMetrics!: BvMetricsService;

  resourceName = ResourceName;

  @action
  serializeQuery(query: IJsonApiQuery = {}) {
    const { entityType, entityId, userId } = this.args;

    const { filter = {} } = query;

    filter.entityType = entityType ? eqFilter(entityType) : niFilter(['sessions']);

    if (entityId) {
      filter.entityIds = inFilter([entityId]);
    }
    if (userId) {
      filter.userId = eqFilter(userId);
    }
    query.filter = filter;
    query.include = 'createdBy';
    return query;
  }
}
